export const Environment = {
  development: 'development',
  stage: 'stage',
  live: 'live',
}
